/**
 * Sets up the routing for all admin views relating to the User resource.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';

// import global components
import AuthoringLayout from '../admin/components/AuthoringLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import contentModule admin views
import AdminContentModuleList from './views/AdminContentModuleList.js.jsx';
import AdminCreateContentModule from './views/AdminCreateContentModule.js.jsx';
import AdminSingleContentModule from './views/AdminSingleContentModule.js.jsx';
import AdminUpdateContentModule from './views/AdminUpdateContentModule.js.jsx';
import AdminBuildContentModule from './views/AdminBuildContentModule.js.jsx';
import AdminContentModulePreview from './views/AdminContentModulePreview.js.jsx';
import AdminCmEvaluationList from '../evaluation/views/AdminCmEvaluationList.js.jsx';

class ContentModuleAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleCMUpdatePath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update'), 0);
    return (

        <Switch>
          <YTRoute
            breadcrumbs={[{display:'All content modules', path: null}]}
            role="admin"
            exact
            path="/admin/authoring/content-modules"
            component={AdminContentModuleList}
          />
          <YTRoute
            breadcrumbs={[{display:'All content modules', path: '/admin/authoring/content-modules'},{display:'New',path:null}]}
            role="admin"
            exact
            path="/admin/authoring/content-modules/new"
            component={AdminCreateContentModule}
          />
          <YTRoute
            breadcrumbs={[{display:'All content modules', path: '/admin/authoring/content-modules'},{display:'Details',path:null}]}
            role="admin"
            exact
            path="/admin/authoring/content-modules/:contentModuleId"
            component={AdminSingleContentModule}
          />
          <YTRoute
            breadcrumbs={[{display:'All content modules', path: '/admin/authoring/content-modules'},{display:'Details',path:singleCMUpdatePath}, {display:'Update', path: null}]}
            role="admin"
            exact
            path="/admin/authoring/content-modules/:contentModuleId/update"
            component={AdminUpdateContentModule}
          />
          <YTRoute
            role="admin"
            exact
            path="/admin/authoring/content-modules/:contentModuleId/preview/:nodeId"
            component={AdminContentModulePreview}
          />
          <YTRoute
            role="admin"
            exact
            path="/admin/authoring/content-modules/:contentModuleId/evaluations"
            component={AdminCmEvaluationList}
          />
        </Switch>

    )
  }
}

export default withRouter(ContentModuleAdminRouter);



// WEBPACK FOOTER //
// modules/contentModule/ContentModuleAdminRouter.js.jsx